<template>
  <div class="mb-8 flex gap-2">
    <InfuseButton
      v-permission="{ ids: [organisationPermissions.UPDATE, tenantOrganisationPermissions.UPDATE], hide: false }"
      color="primary"
      @click="updateModalVisible = true"
    >
      <div class="flex items-center gap-2 font-normal">
        <font-awesome-icon :icon="['far', 'pen-to-square']" />
        {{ t('iam.organisations.header.update_organisation') }}
      </div>
    </InfuseButton>
  </div>

  <IAMEntityInfoTab
    :model="model"
    :show-name="true"
    :show-active="true"
    :show-coc-number="true"
    :show-type="true"
    :type-options="organisationTypeOptions"
  />

  <MutationOrganisationModal
    v-if="updateModalVisible"
    :organisation="model"
    @close="updateModalVisible = false"
    @mutate="async ({ id, organisation }) => { if (!id) return; await updateMutation.mutateAsync({ id, organisation }); updateModalVisible = false; }"
  />
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Organisation, organisationPermissions } from '@infuse/api/iam/organisation';
import { tenantOrganisationPermissions } from '@infuse/api/iam/tenant';
import { IAMEntityInfoTab } from '@infuse/iam/components';
import { organisationTypeOptions } from '@infuse/iam/organisation/ui';
import { useUpdateOrganisation } from '@infuse/iam/organisation/mutations';
import { MutationOrganisationModal } from '@infuse/iam/organisation/ui';
import { vPermission } from '@infuse/iam/permission/directives';
import { InfuseButton } from '@infuse/ui/components';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  model: Organisation;
}>();

const updateModalVisible = ref(false);
const updateMutation = useUpdateOrganisation();
</script>
